
//export const API = 'https://localhost:44307/api/'
export const API = 'https://api.antares.lumago.com.br/api/'
//export const API = 'http://192.168.1.40:8081/api/'


